import { Injectable } from "@angular/core";
import { EpicasBean } from "../shared/model/gestion-proyectos/epicas.model";
import { HistoriaDeUsuario } from "../shared/historiaUsuario";
import { CasoDeUsoBean } from "../shared/casosDeUso";
import { TareaHuCu } from "../shared/model/gestion-proyectos/tareasCuHu";
import { UrlConstantes } from "../utilerias/constantes/urlconstantes";
import { HttpClient } from "@angular/common/http";
import { Discusion } from "../shared/model/gestion-proyectos/discusion";
import { ConsultaList } from "../shared/model/core/ConsultaList.model";
import { environment } from 'src/environments/environment';
import { FlujoAlternoBean } from "../shared/flujo_alterno";
import { SprintModel } from "../shared/model/gestion-proyectos/sprint";
import { Etapa } from "../shared/model/gestion-proyectos/etapa/etapa";
import { ProductosSalidaBean } from "../shared/productosSalida";

const API_URL = environment.apiUrl;
@Injectable({
  providedIn: 'root'
})
export class HucuService {
  
  constructor(private httpClient: HttpClient) { }

  guardarEpica(epica: EpicasBean) {
    return this.httpClient.post<EpicasBean>(UrlConstantes.GUARDAR_EPICA, epica, {});
  }

  guardarHu(hu: HistoriaDeUsuario) {
    return this.httpClient.post<HistoriaDeUsuario>(UrlConstantes.GUARDAR_HU, hu, {});
  }

  guardarCu(cu: CasoDeUsoBean) {
    return this.httpClient.post<CasoDeUsoBean>(UrlConstantes.GUARDAR_CASO_USO, cu, {});
  }

  consultaCuPorProyecto(casoDeUsoBean: CasoDeUsoBean) {
    return this.httpClient.post<CasoDeUsoBean[]>(
      UrlConstantes.CONSULTA_CU_POR_PROYECTO, casoDeUsoBean ,{}
    );
  }

  consultaFlujosAlternos(casoDeUsoBean: CasoDeUsoBean) {
    return this.httpClient.post<FlujoAlternoBean[]>(
      UrlConstantes.CONSULTA_FLUJOS_ALTERNOS, casoDeUsoBean ,{}
    );
  }

  consultaProductosSalida(casoDeUsoBean: CasoDeUsoBean){
    return this.httpClient.post<ProductosSalidaBean[]>(UrlConstantes.CONSULTA_PRODUCTOS_SALIDA, casoDeUsoBean ,{}
    );
  }

  consultaCu(id: number) {
    return this.httpClient.post<ConsultaList<CasoDeUsoBean>>(
      API_URL + 'controller/consultaCu.do',
      id,
      {}
    );
  }

  guardarTask(task: TareaHuCu) {
    return this.httpClient.post<TareaHuCu>(UrlConstantes.GUARDAR_TAREAS, task, {});
  }

  guardarDiscucion(dicuscion: Discusion) {
    return this.httpClient.post<Discusion>(UrlConstantes.GUARDAR_DISCUSION, dicuscion, {});
  }

  consultaTsk(id: number) {
    return this.httpClient.post<ConsultaList<TareaHuCu>>(
      API_URL + 'controller/consultaTareaHucu.do',
      id,
      {}
    );
  }

  consultaHu(id: number) {
    return this.httpClient.post<ConsultaList<HistoriaDeUsuario>>(
      API_URL + 'controller/consultaHu.do',
      id,
      {}
    );
  }

  consultaEpicasxProyecto(idProyecto: number) {
    return this.httpClient.post<ConsultaList<EpicasBean>>(
      API_URL + 'controller/epicasxProyecto.do',
      idProyecto,
      {}
    );
  }

  consultaEpica(id: number) {
    return this.httpClient.post<ConsultaList<EpicasBean>>(
      API_URL + 'controller/consultaEpic.do',
      id,
      {}
    );
  }

  consultaSprint(sprint:SprintModel) {
    return this.httpClient.post<ConsultaList<SprintModel>>(
      UrlConstantes.CONSULTA_SPRINT_POR_ETAPA,sprint,{}
    ); 
  }

  saveSprint(sprint: SprintModel) {
    return this.httpClient.post<SprintModel>(UrlConstantes.SAVE_SPRINT, sprint, {});
  }

  consultaCuXProyecto(idProyecto: string) {
    return this.httpClient.post<ConsultaList<CasoDeUsoBean>>(
      API_URL + 'controller/consultaCuXProyecto.do',
      idProyecto,
      {}
    );
  }

  consultaHuXProyecto(idProyecto: string) {
    return this.httpClient.post<ConsultaList<HistoriaDeUsuario>>(
      API_URL + 'controller/consultaHuxProyecto.do',
      idProyecto,
      {}
    );
  }

  consultaTareaXTipo(consultaObject: ConsultaList<TareaHuCu>) {

    return this.httpClient.post<ConsultaList<TareaHuCu>>(UrlConstantes.CONSULTA_TAREA_X_TIPO, consultaObject);
  }

}